import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white/95'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://static.readdy.ai/image/a217ef276c86b3f83e8ac6a753790dbf/ed9fe3a5ad6190d6ed0f845908f8f102.png" 
              alt="Toolbox Property Pros Logo" 
              className="h-12 w-auto"
            />
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-orange-500 transition-colors font-medium cursor-pointer">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-orange-500 transition-colors font-medium cursor-pointer">
              Services
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-orange-500 transition-colors font-medium cursor-pointer">
              About Us
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-orange-500 transition-colors font-medium cursor-pointer">
              Contact
            </button>
          </div>

          <div className="flex items-center space-x-4">
            <a href="tel:+16262447341" className="hidden lg:flex items-center space-x-2 text-gray-700 hover:text-orange-500 transition-colors">
              <i className="ri-phone-line text-xl"></i>
              <span className="font-medium">(626) 244-7341</span>
            </a>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2.5 rounded-full font-medium transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              Get Free Quote
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}